import { render, staticRenderFns } from "./afterOrderDetail.vue?vue&type=template&id=27236246&scoped=true"
import script from "./afterOrderDetail.vue?vue&type=script&lang=js"
export * from "./afterOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./afterOrderDetail.vue?vue&type=style&index=0&id=27236246&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27236246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27236246')) {
      api.createRecord('27236246', component.options)
    } else {
      api.reload('27236246', component.options)
    }
    module.hot.accept("./afterOrderDetail.vue?vue&type=template&id=27236246&scoped=true", function () {
      api.rerender('27236246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/afterOrderList/afterOrderDetail.vue"
export default component.exports